































































































import Vue from "vue";
import { Component,  Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { GrantData } from "@/entities";
import { Utilities as utils } from "@/shared/utilities";
import { Workspace, ApplicationSubmit } from "@/entities"
import { AppConstants as _app } from "@/shared/app.constants";
import { Locales } from "@/i18n/locales";

const namespace: string = "grant";

@Component
export default class GrantMonitoringSummary extends Vue {

    @State(namespace) grant!: GrantData;
    @State("application") application!: Workspace;
    @Getter("appSubmit", { namespace: "application" }) appSubmit: ApplicationSubmit;
    @Action("getApplication", { namespace:"application" }) getApplication: any;
    @Action("resetAppState", { namespace:"application"}) resetAppState: any;
    @Action("setApplicationId", { namespace:"application" }) setApplication: any;
    @Getter("rootTemplate", { namespace:"application" }) schema: any;
    @Getter("_appUser", { namespace: "RootApp" }) _username!: string;
    @Getter("projectYrs", { namespace: "application" }) years: any;
    @Getter("reportingFrequency", { namespace: "application" }) reportingFreq: any;
    defaultLocale: string = localStorage.getItem("language") || Locales.EN;

    formatCurrency(val, currency) {
        return utils.formatCurrency(val, currency, this.defaultLocale);
    }
    download(proposalId) {      
        let self = this;
        const appId = typeof proposalId === "string" ? parseInt(proposalId) : proposalId;
        this.getApplication(appId).then((data: any) => {
            if (data && data.projectTitle) {
                this.generatePdf();
            }
        })
    }

  generatePdf() {
 let applicationData;

switch (this.application.application.BudgetType) {
  case 'Tiger':
    applicationData = {
      ...this.application.data,
      amountOfMatchingFund: this.application.data.applicationBudget.summary.totalBudget.matchFunding || 0
    };
    break;
  case 'CAG':
    applicationData = {
      ...this.application.data,
      fundingRequests: this.application.data.totalProjectBudgect || 0
    };
    break;
  default:
    applicationData = this.application.data;
    break;
}
    this.$services.pdf.generate({
        entity: "Application",
        schema: this.schema,
        data: applicationData,
        user: this._username,
        code: this.application.application.Code,
        currency: this.application.application.BudgetCurrency,
        id: this.application.application.ApplicationId,
        type: this.application.templates["IsRAGTemplate"] ? "RAG" : "TSG",
        "checklist": this.appSubmit.checklist,
        "years":this.years,
        "Quaters":this.reportingFreq,
        "logSchema": this.application.logSchema
    });
  }   
}
